import * as React from 'react'

import { Localized } from '../../localization/react'
import isSameDay from '../../utilities/isSameDay'
import FormatDate, { DateValue } from '../FormatDate/FormatDate'
import FormatTime from '../FormatTime'
import TimeRange from '../TimeRange'

interface Props {
  start: DateValue
  end: DateValue
}

const DateTimeRange: React.FC<React.PropsWithChildren<Props>> = ({ start, end }) => {
  const startDate = new Date(start)
  const endDate = new Date(end)

  if (isSameDay(startDate, endDate)) {
    return (
      <Localized
        id="same-day-date-time-range"
        params={{
          date: <FormatDate variant="full" value={start} />,
          time: <TimeRange variant="short" start={start} end={end} />,
        }}
      />
    )
  }
  return (
    <Localized
      id="date-time-range"
      params={{
        startDate: <FormatDate variant="full" value={start} />,
        startTime: <FormatTime variant="short" value={start} />,
        endDate: <FormatDate variant="full" value={end} />,
        endTime: <FormatTime variant="short" value={end} />,
      }}
    />
  )
}

export default DateTimeRange
